import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import axios from 'axios'
import moment from 'moment'

import { Modal, Button, Spin, Row, Col } from 'antd'

// Components
import StockBalanceIsDirty from '../../master-data/stock-balance/componants/StockBalanceIsDirty'
import UpdateSyncMorningStockModal from './UpdateSyncMorningStockModal'

class SyncMorningStockModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      check_morning_stock: false,
      update_sync_morning_stock: false,
      payloadUpdate: {},

      reload_data: false,
    }
  }

  componentDidMount() {
    if (this.props.auth.profile.plant_location_list) {
      //example : "1,2,3,4,5,6"
      // เช็คว่าต้องมี plant_location_list ไม่เกิน 10 โรงงาน
      let plant_location_list = this.props.auth.profile.plant_location_list.split(
        ','
      )

      let is_bluenet_user = this.props.auth.profile.is_bluenet_user
      if (plant_location_list.length <= 10 && is_bluenet_user) {
        this.checkMorningStock()
      }
    }
  }

  // TODO:เช็คก่อนว่ามียอดเคาะเช้าหรือไม่
  checkMorningStock = () => {
    let self = this
    let checkMorningStock = false
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/check-stock-balance-is-dirty`,
        {
          filterObj: {
            filter_obj_stock_date_start: moment().format('YYYY-MM-DD'),
            filter_obj_stock_date_end: moment().format('YYYY-MM-DD'),
          },
          location_visibility: this.props.auth.profile.location_visibility,
          material_visibility: this.props.auth.profile.material_visibility,
        },
        {
          headers: { Authorization: `Bearer ${this.props.auth.accessToken}` },
        }
      )
      .then(function(response) {
        let response_data = response.data
        if (response_data.length > 0) {
          checkMorningStock = response_data[0].total > 0 ? true : false
        }

        self.setState(
          {
            check_morning_stock: checkMorningStock,
          },
          () => {}
        )
      })
      .catch(function(error) {
        console.log(error)

        self.setState(
          {
            check_morning_stock: checkMorningStock,
          },
          () => {}
        )
      })
  }

  handleModalCancel = () => {
    this.setState(
      {
        check_morning_stock: false,
        update_sync_morning_stock: false,
        payloadUpdate: {},
      },
      () => {
        // ถ้ากดปิดเองไม่ต้องเช็คอีก
        // this.checkMorningStock()
      }
    )
  }

  openUpdateSyncMorningStockModal = (data) => {
    this.setState({
      update_sync_morning_stock: true,
      payloadUpdate: data,
    })
  }

  closeUpdateSyncMorningStockModal = () => {
    this.setState(
      {
        update_sync_morning_stock: false,
        payloadUpdate: {},
        reload_data: true,
      },
      () => {
        this.checkMorningStock()
      }
    )
  }

  resetReloadData = () => {
    this.setState({
      reload_data: false,
    })
  }

  render() {
    const {
      check_morning_stock,
      update_sync_morning_stock,
      payloadUpdate,
      reload_data,
    } = this.state

    return (
      <Modal
        className='sync-morning-stock-modal'
        title={
          i18n[this.props.language].s
            .siloSelectionSystemForMorningSalesFromBluenet
        }
        visible={check_morning_stock}
        onCancel={() => {
          this.handleModalCancel()
        }}
        okText={null}
        width={1000}
        closable={true}
        footer={null}
        keyboard={false} // This prevents closing on escape
        maskClosable={false} // This prevents closing on blur
      >
        <StockBalanceIsDirty
          serviceType='modalCheckSyncMorningStock'
          editAction={this.openUpdateSyncMorningStockModal}
          reload_data={reload_data}
          resetReloadData={this.resetReloadData}
          visible={check_morning_stock}
        />

        {/* modal แก้ไข stock */}
        <UpdateSyncMorningStockModal
          serviceType='modalCheckSyncMorningStock'
          visible={update_sync_morning_stock}
          payloadUpdate={payloadUpdate}
          onCancel={this.closeUpdateSyncMorningStockModal}
        />
      </Modal>
    )
  }
}

export default connect(
  ({ auth, ui: { language } }) => ({
    auth,
    language,
  }),
  {}
)(SyncMorningStockModal)
